// extracted by mini-css-extract-plugin
export default {"contactLinksSection":"ContactLinks_contactLinksSection__CtNbO","contactButton":"ContactLinks_contactButton__HqE1K"};